// 9fbef606107a605d69c0edbcd8029e5d
import isEmpty from 'lodash/isEmpty';
import { cropImageUrl } from '@tcp/core/src/utils';
import { SPACING_M, SPACING_T, SPACING_D } from '../constants/ModuleContainer.constants';

export const removeEmpty = (obj) => {
  const newObj = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key] && typeof obj[key] === 'object') {
      newObj[key] = removeEmpty(obj[key]); // recurse
    } else if (obj[key] != null) {
      newObj[key] = obj[key]; // copy value
    }
  });
  return newObj;
};

export const flattenColumnSet = (arrVal) => {
  const columnSet = {};
  const { set } = arrVal;
  if (set && Array.isArray(set)) {
    const setLength = set.length;
    for (let i = 0; i < setLength; i += 1) {
      columnSet[set[i].key] = set[i].val;
    }
  }
  return columnSet;
};

export const getColumnSpacing = (columnSet) => {
  return {
    spacingM: columnSet[SPACING_M],
    spacingT: columnSet[SPACING_T],
    spacingD: columnSet[SPACING_D],
  };
};

export const getOverlayVariation = (compositeData) => {
  const [
    {
      variation,
      position,
      positionDLeft,
      positionDTop,
      positionDRight,
      positionTLeft,
      positionTTop,
      positionTRight,
      positionMLeft,
      positionMTop,
      positionMRight,
    },
  ] = compositeData || [{}];

  return {
    variation,
    position,
    positionDLeft,
    positionDTop,
    positionDRight,
    positionTLeft,
    positionTTop,
    positionTRight,
    positionMLeft,
    positionMTop,
    positionMRight,
  };
};

export const getOverlayVariationApp = (compositeData) => {
  const [{ variation, position, positionMLeft, positionMTop, positionMRight }] = compositeData || [
    {},
  ];

  return {
    variation,
    position,
    positionMLeft,
    positionMTop,
    positionMRight,
  };
};

export const getBackgroundMedia = (column) => {
  const background = (column && column.background) || {};
  const { url: bkgImgDUrl, url_m: bkgImgMUrl } = background.image || {};
  const { color } = background.color || {};

  return {
    bkgColor: color,
    bkgImgSource: { uri: (bkgImgDUrl || bkgImgMUrl) && cropImageUrl(bkgImgMUrl || bkgImgDUrl) },
  };
};

export const getBkgImgUrl = (background) => {
  const { url: bkgImgDUrl, url_t: bkgImgTUrl, url_m: bkgImgMUrl } = background.image || {};
  return { bkgImgDUrl, bkgImgTUrl, bkgImgMUrl };
};
export const getBkgColor = (background) => {
  return background.color ? background.color.color : null;
};

export const getBkgImgSrc = (bkgImgUrl, viewport) => {
  if (viewport === 'desktop') {
    return cropImageUrl(bkgImgUrl.bkgImgDUrl || '');
  }
  if (viewport === 'mobile') {
    return cropImageUrl(bkgImgUrl.bkgImgMUrl ? bkgImgUrl.bkgImgMUrl : bkgImgUrl.bkgImgDUrl);
  }
  return '';
};

export const getNonDecimalNumber = (widthValue) => widthValue.toString().split('.')[0];

export const getLiveTextBottomView = (styleOverrides) => {
  const { liveTextHeaderBottom = {} } = styleOverrides;
  return !isEmpty(styleOverrides) && !isEmpty(liveTextHeaderBottom)
    ? liveTextHeaderBottom.isLiveTextHeaderBottomViewEnabled
    : false;
};

export const swapKeysOrder = (keysArray, key1, key2, shouldSwap) => {
  if (shouldSwap) {
    const newArray = [...keysArray];
    const index1 = newArray.indexOf(key1);
    const index2 = newArray.indexOf(key2);

    if (index1 !== -1 && index2 !== -1) {
      [newArray[index1], newArray[index2]] = [newArray[index2], newArray[index1]];
    }

    return newArray;
  }
  return keysArray;
};
